import {
  init,
  miniApp,
  useSignal,
  expandViewport, setMiniAppHeaderColor,
} from '@telegram-apps/sdk-react';
import {AppRoot} from '@telegram-apps/telegram-ui';
import {Router} from "@/navigation/routes.tsx";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {ErrorState} from "@/components/ErrorState.tsx";
import {ErrorBoundary} from "@/components/ErrorBoundary.tsx";

function ErrorBoundaryError({ error }: { error: unknown }) {
  const { t } = useTranslation();
  if (import.meta.env.MODE === 'development') {
    return <div>
      <p>An unhandled error occurred:</p>
      <blockquote>
        <code>
          {error instanceof Error
            ? error.message
            : typeof error === 'string'
              ? error
              : JSON.stringify(error)}
        </code>
      </blockquote>
    </div>
  }

  return (
    <ErrorState title={""} description={t("state.unknownError")}/>
  );
}

export function App() {
  init();
  expandViewport();
  const isDark = useSignal(miniApp.isDark);

  useEffect(()=>{
    if (setMiniAppHeaderColor.supports.rgb()) {
      const color = getComputedStyle(document.documentElement)
        .getPropertyValue('--tg-theme-secondary-bg-color');
      // @ts-expect-error it's ok
      setMiniAppHeaderColor(color);
    } else if (setMiniAppHeaderColor.isAvailable()) {
      setMiniAppHeaderColor("secondary_bg_color");
    }
  })

  return (
    <AppRoot
      style={{ backgroundColor: 'var(--tgui--secondary_bg_color)' }}
      appearance={isDark ? 'dark' : 'light'}
      platform={'ios'}
    >
      <ErrorBoundary fallback={ErrorBoundaryError}>
        <Router/>
      </ErrorBoundary>
    </AppRoot>
  );
}
